import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const Cartes = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/cartes/1.jpg',
    '/images/cartes/2.jpg',
    '/images/cartes/3.jpg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Cartes</h2>
            <p>
            IMPRESSION TOUS TYPES DE CARTES SUR MESURE TELS QUE CARTES DE REMERCIMENT ; cartes de visite ;brochure ;depliant 
            </p>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cartes;